<script>
export default {
  name: "ModeRadio",
  functional: true,
  render: function (h, { props, parent, children, listeners, ...args }) {
    const { name, enumValues, value, disabled = false, showLabel } = props;
    const change = listeners.change;
    return (
      <div class="ModeRadio">
        {<span class="scence_ctr_span_title">{name}</span>}
        {enumValues.map(el =>
          <div key={el.Value} class={`ModeRadioItem ${value == el.Value ? 'ModeRadioItemActive' : ''}`} onClick={() => { change(el.Value) }}>
            <span>{el.Name}</span>
          </div>
        )}
      </div>

    )
  }
}
</script>

<style lang="scss" scoped>
@import '~@/components/button/comps-button.scss';

.ModeRadio {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 0px !important;
  width: auto;
}

.ModeRadioItem {
  margin-right: 20px;
  border-bottom: 4px solid transparent;
  color: #333333;
  opacity: 0.5;
  margin-top: 3px;
  cursor: pointer;
}

.ModeRadioItemActive {
  color: #333333;
  opacity: 1;
  font-weight: bold;
  border-bottom: 4px solid #3F9EFE;
}
.scence_ctr_span_title{
  //visibility: hidden
}
</style>
